import type {
	IssueSeverity,
	IssueType,
	SummaryItem,
} from '@/components/analysis/summary/types/triage'

const SEVERITY_RANK: Record<IssueSeverity, number> = {
	high: 0,
	medium: 1,
	low: 2,
}

function stepRank(item: SummaryItem, numberMap: Map<string, string>): number {
	const id = item.relatedIds?.[0]
	if (!id) return Number.POSITIVE_INFINITY
	const label = numberMap.get(id)
	if (!label) return Number.POSITIVE_INFINITY
	const parsed = Number.parseInt(label, 10)
	return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY
}

export function sortByImpactThenStep(
	items: SummaryItem[],
	numberMap: Map<string, string>
): SummaryItem[] {
	return [...items].sort((a, b) => {
		const severity = SEVERITY_RANK[a.severity ?? 'medium'] - SEVERITY_RANK[b.severity ?? 'medium']
		if (severity !== 0) return severity
		return stepRank(a, numberMap) - stepRank(b, numberMap)
	})
}

export const REVIEW_TYPE_FILTERS: IssueType[] = ['bottleneck', 'exception', 'question']

export function itemMatchesTypeFilter(
	item: SummaryItem,
	selected: ReadonlySet<IssueType>
): boolean {
	const type = item.type ?? 'question'
	return selected.has(type)
}
